// Odômetro e horímetro chegam do servidor com a imprecisão do ponto flutuante
// (4464.4348899999995); a tela mostra no máximo duas casas.
export const formatMeasure = (value?: number | null): string =>
  value == null ? '' : String(Math.round(value * 100) / 100);
